export default __webpack_public_path__ + "static/media/RDS.aeaa1a81.svg";